export default {
  userSignatures: [],
  userSignature: undefined,
};
